<template>
	<div class="card-calendar ">
		<calendar :masTasks="setCalendarTasks(masTasks)" :strCalendarView="strCalendarView"  @prev="onPrev" @next="onNext"></calendar>
	</div>
</template>
<script>
	/*  We lazy load (async) the Calendar component because it contains 2 big libraries (jquery and fullcalendar)
				If the component is not loaded within 100ms, we display a loading component in the meanwhile.
				This way, we don't bloat the main bundle with 2 unnecessary libs that we only need for this page :)
	*/
	import Loading from 'src/our_pages/Layout/LoadingMainPanel.vue';

	const Calendar = () => ({
		component: import('src/our_components/Calendar/Calendar.vue'),
		loading: Loading,
		delay: 100
	});
	const today = new Date();
	const y = today.getFullYear();
	const m = today.getMonth();
	const d = today.getDate();
	export default {
		name: 'ReCalendar',
		components: {
			Calendar,
		},
		props: {
			masTasks: {
				type: Array,
				default(){return [];}
			},
			strCalendarView: {
				type: String,
				default: 'dayGridMonth' // ['dayGridMonth' || 'timeGridDay' || 'timeGridWeek']
			},
			// strCalendarType: {
			// 	type: String,
			// 	default: 'commonCalendar',
			// 	// default: 'lawCalendar'
			// }
		},
		data () {
			return {
				ver: 1,
				
			}
		},
		computed: {
			
		},
		methods: {
			setCalendarTasks(masTasks){
				//console.log(masTasks);
				let masEvents = [];
				if(masTasks.length > 0){
					for (let i = 0; i < masTasks.length; i++) {
						let objEvent = {};
						let agentfio = '';
						objEvent['id'] = masTasks[i].id;
						objEvent['url'] = '/data/tasks/id/'+objEvent['id'];
						if(masTasks[i].agent_fio != undefined){
							agentfio = masTasks[i].agent_fio.split(" ").slice(0, 1);
						}
						if(masTasks[i].agent_name != undefined){
							agentfio = masTasks[i].agent_name.split(" ").slice(0, 1);
						}
						// objEvent['customHtml'] = this.$GVO.convertDateTimeFromMysqlToDate(masTasks[i].DEADLINE);
						objEvent['title'] = agentfio + ' - ' + masTasks[i].BP_TASK_NAME;
						objEvent['start'] = masTasks[i].STARTDATE;
						if(typeof masTasks[i].DEADLINE != 'undefined') objEvent['end'] = masTasks[i].DEADLINE;//END_DATE "2022-07-03 15:17:37";

						if(masTasks[i].STARTDATE == "3000-12-31 23:59:59") objEvent['start'] = new Date(y, m, d);
						//if(masTasks[i].DEADLINE != "3001-01-01 11:59:59") objEvent['end'] = masTasks[i].DEADLINE;

						objEvent['allDay'] = false;
						let startDateConverted = this.$GVO.convertDateTimeFromMysqlToDate(masTasks[i].STARTDATE);
						let endDateConverted = this.$GVO.convertDateTimeFromMysqlToDate(masTasks[i].DEADLINE);
						
						if(endDateConverted == startDateConverted){
							objEvent['allDay'] = false;
							// console.log('DEADLINE ' + endDateConverted + ' == STARTDATE ' + startDateConverted + ' Таска: ' + objEvent['title'])
						} else {
							objEvent['allDay'] = true;
							// console.log('НЕ РАВНО DEADLINE ' + endDateConverted + ' != STARTDATE ' + startDateConverted  + ' Таска: ' + objEvent['title'])
						}
						objEvent['editable'] = false;
						objEvent['droppable'] = false;
						objEvent['className'] = 'event-primary';
						if(masTasks[i].overdue != 0) objEvent['className'] = 'event-red';
						objEvent['task_data'] = masTasks[i];
						
						masEvents.push(objEvent);
					}
				}
				//masEvents = [...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents,...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents, ...masEvents];
				//console.log(this.$GVO.unlinkObject(masEvents));
				return masEvents;
			},
			onPrev(evt){
				this.$emit('prev',evt);
			},
			onNext(evt){
				this.$emit('next',evt);
			},
			
		},		
		
	}
</script>
<style>
	.card-calendar {
		min-height: 400px;
	}
	.fc-content > *, .fc-event-container .fc-day-grid-event .fc-content{text-align: left;}
	.fc-day-grid-event .fc-content {white-space: normal;}
	
</style>
